import React, { memo } from 'react';
import { Box, IconButton } from '@mui/material';
import { MusicNote, PlayArrow } from '@mui/icons-material';
import { SONOS_BLUE, SURFACE, SURFACE_BORDER } from './sonosUiStyles';

/** Espaciado uniforme entre badge / corazón / cola / playlist / play en filas de temas. */
export const TRACK_ROW_ACTIONS_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  flexShrink: 0,
  ml: 0.5,
  mr: 0.25,
} as const;

export const TRACK_ACTION_ICON_SX = { p: 0.35 } as const;

export const TrackArt = memo<{ url: string | null | undefined; size?: number }>(({ url, size = 40 }) => (
  <Box sx={{
    width: size,
    height: size,
    borderRadius: 1,
    flexShrink: 0,
    bgcolor: SURFACE,
    border: `1px solid ${SURFACE_BORDER}`,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    {url ? (
      <Box
        component="img"
        src={url}
        alt=""
        loading="lazy"
        decoding="async"
        sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    ) : (
      <MusicNote sx={{ color: 'rgba(255,255,255,0.35)', fontSize: size * 0.45 }} />
    )}
  </Box>
));

export const TrackPlayButton: React.FC<{
  disabled?: boolean;
  onClick: () => void;
  size?: 'normal' | 'compact';
}> = ({ disabled, onClick, size = 'normal' }) => {
  const compact = size === 'compact';
  return (
    <IconButton
      disabled={disabled}
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      sx={{
        width: compact ? 28 : 36,
        height: compact ? 28 : 36,
        flexShrink: 0,
        bgcolor: SONOS_BLUE,
        color: '#000',
        '&:hover': { bgcolor: '#1a7ae0' },
        '&.Mui-disabled': { bgcolor: '#333', color: '#666' },
      }}
    >
      <PlayArrow sx={{ fontSize: compact ? 18 : 22 }} />
    </IconButton>
  );
};

export function spotifyImageUrl(item: { images?: { url?: string }[] } | null | undefined): string | null {
  const images = item?.images;
  return images?.[0]?.url ?? null;
}
